import React from "react";
import { CardFormacion } from "./CardFormacion";

interface CardItem {
  img: string;
  title: string;
  linkText: string;
  linkRef: string;
}

interface CardGridProps {
  items: CardItem[];
}

export const CardGrid: React.FC<CardGridProps> = ({ items }) => {
  return (
    <div className="card-grid card-grid-site">
      {items.map((item, index) => (
        <CardFormacion
          key={index}
          imageSrc={item.img}
          title={item.title}
          linkText={item.linkText}
          linkHref={item.linkRef}
        />
      ))}
    </div>
  );
};